import { useTranslate } from '@dreryk/react-common';

import { prescriptionTranslationKeys } from '../../../../../translations';
import { StyledPrescriptionTextView } from '../../prescriptionTextView.styled';

type ExtendedDosageTreatmentDaysCountTextValueProps = {
   readonly treatmentDaysCount: number | undefined;
};

export const ExtendedDosageTreatmentDaysCountTextValue = (
   props: ExtendedDosageTreatmentDaysCountTextValueProps
): JSX.Element => {
   const translate = useTranslate();

   return (
      <StyledPrescriptionTextView
         testId={'extendedDosageTreatmentDaysCount'}
         compact
         label={prescriptionTranslationKeys.numericalDosage.treatmentDaysCount}
      >
         {props.treatmentDaysCount
            ? `${props.treatmentDaysCount} ${translate(prescriptionTranslationKeys.numericalDosage.days)}`
            : '-'}
      </StyledPrescriptionTextView>
   );
};
